export const WAEC_FOOD_NUTRITION = [];
